<template>
    <div class="word-cla">
        <a-button type="primary" @click="showAdd">添加分類</a-button>
        <a-table
                :dataSource="list"
                :loading="loading"
                rowKey="id"
                :pagination="false">
            <a-table-column
                    title="分類名稱"
                    dataIndex="desc">

            </a-table-column>
            <a-table-column
                    title="上傳時間">
                <template slot-scope="row,item,index">
                    {{item.addTime | trans-date}}
                </template>
            </a-table-column>
            <a-table-column
                    title="分類ID"
                    dataIndex="id">

            </a-table-column>
            <a-table-column
                    title="操作">
                <template slot-scope="row,item,index">
                    <a-button style="margin-right:10px;" :disabled="item.id===5 || item.id===6" @click="del(item)" size="small">刪除</a-button>
                    <a-button @click="edit(item)" :disabled="item.id===5 || item.id===6" size="small">編輯</a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-modal
                :title="title"
                :visible="addDia"
                @ok="action"
                :confirmLoading="confirmLoading"
                @cancel="hideAdd"
                cancelText="取消"
                okText="提交"
        >
            <a-input size="large" placeholder="請輸入分類名稱" v-model.trim="text" />
        </a-modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading:false,
                addDia:false,
                confirmLoading:false,
                title:'',
                text:'',
                list:[
                    {name:'祖師聖象',time:'2019-10-19',id:345}
                ],
                editor:false,
                editId:''
            }
        },
        methods: {
            showAdd(){
                this.title='添加叢書分類'
                this.addDia=true;
            },
            action(){
                if(this.text===''){
                    this.$Message.warning('分類名稱不能為空')
                    return false;
                }
                let self=this;
                let url,data;
                if(this.editor){
                    url='/manager/type/noun/update';
                    data={
                        desc:self.text,
                        id:self.editId
                    }
                }else{
                    url='/manager/type/noun/add';
                    data={
                        desc:self.text
                    }
                }
                self.confirmLoading=true;
                this.$http({
                    method: 'post',
                    url: url,
                    data:data
                }).then(function(res){
                    self.$Message.success('操作成功')
                    self.confirmLoading=false;
                    self.addDia=false
                    self.editId=''
                    self.editor=false;
                    self.text='';
                    self.title=''
                    self.getList()
                }).catch(err=>{
                    self.confirmLoading=false;
                })
            },
            getList(){
                let self=this;
                this.loading=true;
                this.$http({
                    method: 'get',
                    url: '/manager/type/noun/list',
                }).then(function(res){
                    self.loading=false;
                    if(res.data && res.data.length){
                        self.list=res.data;
                    }else{
                        self.list=[]
                    }
                }).catch(err=>{
                    self.loading=false;
                })
            },
            hideAdd(){
                this.addDia=false;
                this.text=''
                this.title=''
            },
            edit(item){
                this.editor=true;
                this.editId=item.id;
                this.title='編輯叢書分類';
                this.text=item.desc;
                this.addDia=true;
            },
            del(item){
                let self=this;
                this.$Confirm({
                    title:'確定刪除該分類嗎？',
                    onOk(){
                        self.$http({
                            method: 'post',
                            url: '/manager/type/noun/delete',
                            data:{
                                id:item.id
                            }
                        }).then(function(res){
                            self.$Message.success('操作成功')
                            self.getList()
                        }).catch(err=>{
                        })
                    },
                    onCancel(){
                    }
                })
            }
        },
        created() {
            this.getList();
            this.$emit('breadcrumbChange',['叢書管理','叢書分類'])
        },
    }
</script>
<style lang="less">
    div.word-cla{
        text-align: left;
    }
</style>